document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.featured-product-hero-slider:not(.is-new)')) {
    const splide = new Splide('.featured-product-hero-slider', {
      perPage: 1,
      arrows: true,
      pagination: false,
      breakpoints: {
        768: {
          perPage: 1,
          arrows: true,
          pagination: false,
          drag: true
        },
        99999: {
          perPage: 3,
          arrows: false,
          pagination: false,
          drag: false
        }
      }
    });

    splide.mount();
  }

  if(document.querySelector('.featured-product-hero-slider.is-new')) {
    const splide_2 = new Splide('.featured-product-hero-slider.is-new', {
      perPage: 3,
      arrows: false,
      pagination: false,
      drag: false,
      breakpoints: {
        1023: {
          perPage: 1,
          arrows: true,
          drag: true
        }
      }
    });

    if(document.querySelector('.featured-product-price-slider')){
      const price_splide = new Splide('.featured-product-price-slider', {
        perPage: 3,
        arrows: false,
        pagination: false,
        drag: false,
        breakpoints: {
          1023: {
            perPage: 1,
            arrows: false,
            drag: true
          }
        }
      });
      splide_2.sync(price_splide);
      price_splide.mount();
    }
    splide_2.mount();
  }

  const customDots = document.querySelectorAll('.custom-dot');

  customDots.forEach((dot, index) => {
    dot.addEventListener('click', function () {
      splide.go(index);

      customDots.forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    });
  });

  if (customDots.length > 0) {
    customDots[0].classList.add('active');
  }
});